import { useMemo } from 'react';
import { useTaskContext } from '../../context.js';
import { FacitContainer } from './container.facit.js';
import { InputContainer } from './container.input.js';
import { MinimumTextInputContext } from './context.js';
import { jsx } from 'react/jsx-runtime';

function WriteAnswersOnImageTask(props) {
  const context = useTaskContext();
  const minimumInputLength = useMemo(() => Math.max(...props.task.content.map(it => {
    switch (it.nodeType) {
      case "on-image-text-input":
        return Math.max(...it.validation.correctAnswers.map(answer => answer.length + it.style.extendSizeBy), 0);
      default:
        return 0;
    }
  })), [props.task.content]);
  return /*#__PURE__*/jsx(MinimumTextInputContext.Provider, {
    value: minimumInputLength,
    children: context === "input" ? /*#__PURE__*/jsx(InputContainer, {
      ...props
    }) : /*#__PURE__*/jsx(FacitContainer, {
      ...props
    })
  });
}

export { WriteAnswersOnImageTask };
//# sourceMappingURL=_task.on-image.js.map
